export const requestMessage = (emailReport) => {
  if (emailReport) {
    return 'Report generation can take several minutes. The link will appear here soon and in your email inbox as an attachment.';
  } else {
    return 'Report generation can take several minutes. The link will appear here soon.';
  }
};
